import {
  configureApiClient,
  ApiRequestError,
  authApi,
  adminApi,
  USER_STATUSES,
  REPORT_STATUSES,
  REPORT_REASONS,
  REPORT_TARGET_TYPES,
  POST_CATEGORIES,
  MEMBER_ROLES,
  MEDIA_RESOURCE_TYPES,
  ADMIN_MESSAGE_TYPES,
} from "@davorai/shared";

import {
  notifySessionRestored,
  redirectToLoginOnce,
} from "./auth-events";
import { DEFAULT_LANGUAGE, readStoredLanguage } from "@/i18n/settings";

/** Same-origin prefix. Caddy and the Vite dev server strip `/api` before the community API. */
export const API_BASE = "/api";
export const APP_URL = import.meta.env.VITE_APP_URL ?? "http://localhost:3001";

function getRequestLanguage(): string {
  if (typeof window === "undefined") return DEFAULT_LANGUAGE;
  return readStoredLanguage() ?? DEFAULT_LANGUAGE;
}

configureApiClient({
  apiBase: API_BASE,
  authMode: "cookie",
  credentials: "include",
  refreshPath: "/api/auth/refresh",
  getLanguage: getRequestLanguage,
  onSessionExpired: redirectToLoginOnce,
  onSessionRestored: notifySessionRestored,
});

export {
  ApiRequestError,
  authApi,
  adminApi,
  USER_STATUSES,
  REPORT_STATUSES,
  REPORT_REASONS,
  REPORT_TARGET_TYPES,
  POST_CATEGORIES,
  MEMBER_ROLES,
  MEDIA_RESOURCE_TYPES,
  ADMIN_MESSAGE_TYPES,
};

export type {
  ApiErrorCode,
  AuthResponse,
  StaffUser,
  StaffAuthResponse,
  AdminStaffListItem,
  UserStatus,
  ReportStatus,
  PostCategory,
  ReportTargetType,
  ReportReason,
  MemberRole,
  MediaResourceType,
  AdminMessageType,
  AdminUserListItem,
  AdminUserDetail,
  PaginatedAdminUsersResponse,
  UpdateAdminUserPayload,
  AdminReportListItem,
  AdminReportDetail,
  AdminReportTargetPreview,
  AdminPostTargetPreview,
  AdminCommentTargetPreview,
  AdminMessageTargetPreview,
  AdminProfileTargetPreview,
  PaginatedAdminReportsResponse,
  PatchAdminReportPayload,
  AdminCommunityListItem,
  PaginatedAdminCommunitiesResponse,
  CreateAdminCommunityPayload,
  UpdateAdminCommunityPayload,
  AdminChannelListItem,
  CreateAdminChannelPayload,
  UpdateAdminChannelPayload,
  AdminCommunityMember,
  AdminSkillListItem,
  PaginatedAdminSkillsResponse,
  CreateAdminSkillPayload,
  UpdateAdminSkillPayload,
  AdminPlatformListItem,
  PaginatedAdminPlatformsResponse,
  CreateAdminPlatformPayload,
  UpdateAdminPlatformPayload,
  AdminPost,
  AdminComment,
  AdminPaginatedResponse,
  UpdateAdminPostPayload,
  AdminDashboardStats,
  AdminDashboardActivity,
  AdminAuditLog,
  PaginatedAdminAuditLogsResponse,
  BroadcastNotificationPayload,
  Media,
} from "@davorai/shared";
